export function toNumberOrNull(rawValue: string): number | null {
    const trimmed = rawValue.trim();
    if (!trimmed.length) {
        return null;
    }

    const parsed = Number(trimmed);
    return Number.isFinite(parsed) ? parsed : null;
}

export function toPlainNumberString(value: string | number): string {
    if (typeof value === 'string') {
        return value;
    }

    if (!Number.isFinite(value)) {
        return '';
    }

    const asString = value.toString();
    if (!/[eE]/.test(asString)) {
        return asString;
    }

    return value.toLocaleString('en-US', {
        useGrouping: false,
        maximumSignificantDigits: 21,
    });
}

export function parseBooleanString(rawValue: unknown): boolean | null {
    if (rawValue === 'true' || rawValue === true) return true;
    if (rawValue === 'false' || rawValue === false) return false;
    return null;
}
